import { PlacesBase } from './api-common.js';
import { BASE_API_URL } from '../envs.js';
export class Travelreport extends PlacesBase {
    constructor(data) {
        super(data);
        if (typeof data.get === 'function')
            this.url = data.get('url_travelreport');
        else
            Object.assign(this, data);
    }
}
export async function fetchTravelreports(ids) {
    const response = await fetch(`${BASE_API_URL}/api/4/feature/travelreport/${ids.join(',')}`);
    return (await response.json()).map((travelreport) => new Travelreport(travelreport));
}
//# sourceMappingURL=api-travelreports.js.map